<template>
    <div class="sub-menu-container">
        <a class="parent-url-button" :href="activeConfig.activeParentUrl">
            <typo class="sub-menu-prent-title" name="menu-16-normal" v-if="sticky">
                {{ activeConfig.activeParentTitle }}
            </typo>
        </a>
        <div class="sub-menu">
            <a
                v-for="item in activeConfig.subMenu"
                :key="item._uid"
                :href="item.url && item.url"
                @click="item.scroll_to && scrollTo(item.scroll_to)"
            >
                <sub-menu-item :isActive="item.id === activeConfig.activeChildId">
                    {{ item.__title }}
                </sub-menu-item>
            </a>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import SubMenuItem from "./SubMenuItem.vue";
import scrollManager from "src//components/convention/managers/scrollManager";

export default Vue.extend({
    props: ["activeConfig", "sticky"],
    components: {
        SubMenuItem,
    },
    methods: {
        scrollTo(dest) {
            scrollManager.scrollToIdSmooth(dest);
        },
    },
});
</script>

<style lang="sass" scoped>
a
    display: inline-block
    text-decoration: none
    +r(1140)
        margin-bottom: 8px
    &:hover
        .sub-menu-item
            color: $color-main

.parent-url-button
    color: $color-text
    transition: color .15s ease
    &:hover
        color: $color-main

.sub-menu-container
    display: flex
    align-items: center

.sub-menu-prent-title
    width: 80px
    margin-right: 40px
    text-align: center

.sub-menu
    background: #F2F2F2
    display: flex
    justify-content: stretch
    overflow: hidden
    height: 60px
    width: 100%
    +r(1140)
        height: auto
        flex-direction: column
        margin-bottom: 16px
</style>
